import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const reviewsRoutes = {
  name: 'list-review',
  path: 'reviews',
  component: () => import('./Reviews.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
